import heic2any from 'heic2any';

/**
 * Nếu file là HEIC/HEIF (thường gặp trên iOS), convert sang JPEG.
 * Trả về file gốc nếu không cần convert.
 */
export async function convertHeicIfNeeded(file) {
	if (!file) return file;
	const isHeic =
		file.type === 'image/heic' ||
		file.type === 'image/heif' ||
		/\.(heic|heif)$/i.test(file.name);
	if (!isHeic) return file;
	console.log('[HEIC] Converting', file.name, `(${ file.type || 'no type' })`, 'to JPEG...');
	const blob = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.85 });
	const converted = Array.isArray(blob) ? blob[0] : blob;
	const newName = file.name.replace(/\.(heic|heif)$/i, '.jpg');
	const result = new File([converted], newName, { type: 'image/jpeg' });
	console.log('[HEIC] Done:', result.name, result.size, 'bytes');
	return result;
}
